module.exports = __webpack_public_path__ + "img/411-4314f1.png";